<template>
  <div class="article-list-page">
    <!-- 分类筛选 -->
    <div class="article-filters">
      <div
        v-for="type in articleTypes"
        :key="type.id"
        class="filter-item"
        :class="{ active: activeType === type.id }"
        @click="selectType(type.id)"
      >
        {{ type.name }}
      </div>
    </div>

    <!-- 资讯列表 -->
    <div class="article-list-container">
      <div v-if="articles.length > 0" class="articles-list">
        <article-card
          v-for="article in articles"
          :key="article.id"
          :article="article"
          @click="goToArticleDetail"
        />
      </div>
      <empty-state
        v-else
        title="暂无资讯"
        description="该分类下暂无资讯"
        emoji="📰"
        :show-button="true"
        button-text="返回首页"
        @click="goToHome"
      />
    </div>

    <!-- 加载更多 -->
    <div v-if="hasMore && articles.length > 0" class="load-more">
      <button v-if="!loading" class="load-more-btn" @click="loadMore">
        加载更多
      </button>
      <div v-else class="loading-text">加载中...</div>
    </div>
  </div>
</template>

<script>
import { getArticleList } from '@/api/browse'
import ArticleCard from '@/components/article-card/article-card.vue'
import EmptyState from '@/components/empty-state/empty-state.vue'

export default {
  name: 'ArticleList',
  components: {
    ArticleCard,
    EmptyState
  },
  data() {
    return {
      articleTypes: [],
      activeType: '',
      articles: [],
      pageIndex: 1,
      pageSize: 20,
      hasMore: true,
      loading: false
    }
  },
  async mounted() {
    // 从路由参数获取资讯类型 ID
    const articleTypeId = this.$route.query.articleTypeId
    if (articleTypeId) {
      this.activeType = articleTypeId
    }
    await this.loadArticleTypes()
    this.loadArticles()
  },
  methods: {
    async loadArticleTypes() {
      try {
        const types = await this.$store.dispatch('dict/loadDict', 'article_type')
        this.articleTypes = [
          { id: '', name: '全部' },
          ...(types || []).map(t => ({ id: String(t.id), name: t.label }))
        ]
      } catch (error) {
        console.error('加载资讯类型失败:', error)
      }
    },
    selectType(typeId) {
      this.activeType = typeId
      this.pageIndex = 1
      this.hasMore = true
      this.articles = []
      this.loadArticles()
    },
    async loadArticles() {
      if (this.loading) return

      this.loading = true
      try {
        const body = { PageIndex: this.pageIndex, PageSize: this.pageSize }
        if (this.activeType) body.DictDataId = [parseInt(this.activeType)]
        const res = await getArticleList(body)

        if (this.pageIndex === 1) {
          this.articles = res.data || []
        } else {
          this.articles.push(...(res.data || []))
        }

        this.hasMore = (res.data || []).length >= this.pageSize
      } catch (error) {
        console.error('加载资讯列表失败:', error)
        this.$alert('加载失败，请重试')
      } finally {
        this.loading = false
      }
    },
    loadMore() {
      this.pageIndex++
      this.loadArticles()
    },
    goToArticleDetail(article) {
      this.$router.push({
        name: 'ArticleDetail',
        params: { id: article.id }
      })
    },
    goToHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.article-list-page {
  width: 100%;
  min-height: 100vh;
  background: #f9fafb;
}

.article-filters {
  display: flex;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 10;
  overflow-x: auto;
  padding: 0 16px;

  &::-webkit-scrollbar {
    display: none;
  }
}

.filter-item {
  padding: 12px 16px;
  font-size: 14px;
  color: #6b7280;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: all 0.3s ease;

  &.active {
    color: #ff720d;
    border-bottom-color: #ff720d;
  }
}

.article-list-container {
  padding: 12px;
}

.articles-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.load-more {
  padding: 20px 16px;
  text-align: center;
}

.load-more-btn {
  width: 100%;
  max-width: 200px;
  padding: 10px 20px;
  background: linear-gradient(90deg, #ffa43a 0%, #ff720d 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:active {
    opacity: 0.8;
  }
}

.loading-text {
  font-size: 14px;
  color: #6b7280;
}
</style>
